
import React from 'react';
import { useTranslation } from '../context/LanguageContext';
import { useGuest } from '../context/GuestContext';
import '../styles/Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const { guest } = useGuest();
  return (
    <footer className="footer">
      <p>
        {guest?.special === 'amiker'
          ? "Made with love (and mild stress) by the bride & groom"
          : guest?.special === 'gergely'
          ? "Made with love (and way too many late nights) by the groom & bride"
          : t('footer.text')}
      </p>
    </footer>
  );
};

export default Footer;
